import { InfinitySpin } from "react-loader-spinner";

export default function Loader() {
    return (
        <div className="position-fixed d-flex justify-content-center align-items-center vh-100 vw-100 wahed-z-index">
            <div className="d-flex justify-content-center align-items-center">
                <InfinitySpin width={200} color="#49c628" height={200} />
            </div>
        </div>
    );
}